export default __webpack_public_path__ + "static/media/omni.3fb92610.svg";